import { MessageType } from '../enums/MessageType';
import { DbTable } from '../enums/DbTable';
import { SearchTarget } from '../enums/SearchTarget';

export class Message
{
    messageType: MessageType = MessageType.none;
    value: any;
    values: any[];
    messageSubject: any;
    message: string;
    dqoiIndex: number;
    searchTarget: SearchTarget;
    refreshTarget: DbTable;

    constructor(message: Partial<Message> = {}) {
        Object.assign(this, message);
    }
}